import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, combineLatest, takeUntil } from 'rxjs';

import { DataViewFacade } from '@mode/switch-views/contract';
import { CodeHighlightComponent } from '@mode/switch-views/ui';

@Component({
  standalone: true,
  selector: 'mode-query',
  imports: [CodeHighlightComponent, CommonModule],
  templateUrl: './query.component.html',
  styleUrls: ['./query.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QueryComponent implements OnInit, OnDestroy {
  @Input({ required: true }) queryId!: string;
  @Input() isRawQuery = false;

  rawQuery: string | undefined;
  renderedQuery: string | undefined;
  private readonly _destroy$ = new Subject<void>();

  constructor(
    private _dataViewFacade: DataViewFacade,
    private _changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    combineLatest([
      this._dataViewFacade.getRawQueryByQueryToken(this.queryId),
      this._dataViewFacade.getRenderedQueryByQueryToken(this.queryId),
    ])
      .pipe(takeUntil(this._destroy$))
      .subscribe({
        next: ([rawQuery, renderedQuery]) => {
          this.rawQuery = rawQuery;
          this.renderedQuery = renderedQuery;
          this._changeDetectorRef.markForCheck();
        },
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
